import React from 'react'
import PropTypes from 'prop-types'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import Terms from '../components/Terms'
import Heading from '../components/Heading'

class ThingsToKnow extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            data: []
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getThingsToKnow/${this.props.type}`, result => {
            this.setState({
                data: result.data,
                isLoaded: true
            })
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        return (
            <div className='terms module font-small'>
                <Heading title='Things you need to know' />
                <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError} className='p-4'>
                    <div className='row'>
                        <div className='col-12'>
                            <Terms data={this.state.data} />
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

ThingsToKnow.propTypes = {
    type: PropTypes.string.isRequired
}

export default ThingsToKnow



// WEBPACK FOOTER //
// ./resources/js/modules/ThingsToKnow.js